/*global define, $, ol, window, queryCommandSupported*/
import layerhelp from "./helptextgenerator.js";
import globals from "../globals.js";
"use strict";
var privateFns, clickFns, intranett;
intranett = globals.intranett;
let layerIds = {
	"veitype": "veitype",
	"maringrense": "maringrense",
	"steinsprang": "kp_pk2_2",
	"elveflom": "kp_pk2_2",
	"gulliste": "gulliste",
	"tidligereAvfallsdeponi": "kp_pk2_2",
	"trafikkmengde": "trafikkmengde",
	"fartsgrenser": "fartsgrenser",
	"drenering": "drenering",
	"kvikkleire": "kp_pk2_2",
	"ledning": "kp_pk1-2_hensynssoner",
	"funnpotensiale": "funnpotensiale",
	"spor": "kp_pk1-2_juridisk",
	"fjernvarme": "fjernvarme",
	"blagronn_faktor": "blagronn_faktor",
	"naturmangfold": "naturmangfold",
	"marka": "markagr",
	"MFT": "MFT",
	"vann": "vann",
	"stoy": "kp_tema_juridisk_stoy",
	"stormflo": "kp_pk2_2",
	"storulykke": "kp_tema_juridisk_storulykke",
	"forurensetgrunn": "forurenset_grunn",
};
privateFns = {
	tipWindow: function (tipText) {
		var section = document.createElement("section");
		section.innerHTML = tipText;
		return section;
	},
	showHintWin: function (hint,searchStr, url2, sesjon) {
		//var tipWin, btnWrapper, okBtn, inputWrapper, hideId = "", hideLabel, hideInput, article;

		var tipWin = document.createElement("div");
		tipWin.className = "tip-win";

		var article = document.createElement("article");
		article.appendChild(privateFns.tipWindow(hint));
		let coordsCt = document.createElement("div");
		coordsCt.id = "coordsCt";
		article.appendChild(coordsCt);
		let coordCheck = document.createElement("input");
		tipWin.appendChild(article);

		var btnWrapper = document.createElement("div");
		btnWrapper.className = "tip-win-btn-wrapper";
		var okBtn = document.createElement("button");
		okBtn.type = "button";
		okBtn.className = "btn btn-default";
		okBtn.innerHTML = "Lag DOK analyse";
		okBtn.onclick = function () {
			let dokUrl;
			if(searchStr.includes(",")){					
				let bbox = privateFns.createbbox();
				dokUrl = encodeURI('https://nfswstest.sesam.pbe.oslo.kommune.no:8443/DOK/dok/list?list=' + searchStr);
			}else{
				if(typeof searchStr == "string");{
					console.log(searchStr);
					console.log(typeof searchStr);
					searchStr = searchStr.split('/');
				}
				dokUrl = encodeURI('https://nfswstest.sesam.pbe.oslo.kommune.no:8443/DOK/dok?gnr=' + searchStr[0] + '&bnr=' + searchStr[1]);
			}
			$.ajax({
				url: dokUrl,
				success:function(data){
					//window.location = url2;
				},
				error:function(){
					alert('An error was encountered.');
				}
			});
		};
		btnWrapper.appendChild(okBtn);
		tipWin.appendChild(btnWrapper);

		var inputWrapper = document.createElement("div");
		inputWrapper.className = "tip-win-input-wrapper";
		
		tipWin.appendChild(inputWrapper);
		$("#map").append(tipWin);
		if (($(tipWin).height() + 60) > $(window).height()) {
			$(article).css("height", $(window).height() - 140);
		}
	},
	DOKHandler: function(gnr, bnr, list){
		privateFns.createDokLayerMenuContainer();
		//Henter fra og med '?' fra urlen.
		let hitListUrl;
		if(list){
			hitListUrl = "http://diversus:8080/DOK/dok/kartgrunnlag/list?list=" + list;
		}else{
			hitListUrl = "http://diversus:8080/DOK/dok/kartgrunnlag?gnr="+ gnr +"&bnr="+bnr;
		}
		$.ajax({
			type: "GET",
			dataType: "json",
			url: hitListUrl,
			success: function(data){
				let hits = {};
				for(let key in data){
					if(data[key].treff){
						hits[key] = layerIds[key];
					}
				}
				privateFns.createDokLayerMenu(hits, gnr, bnr, list);
			}
		});
	},
	createDokLayerMenuContainer: function(){
		if(!document.getElementById("dok-layer-container")){				
			let target = document.getElementById("mapmenu-ct");
			var title = document.createElement("h3");
			title.innerHTML = "DOK";
			title.id = "dok-layer-container";
			title.appendChild(privateFns.createSpinner());
			title.appendChild(privateFns.createGroupExpander());
			let ct = privateFns.createGroupContainer("DOK");
			title.appendChild(ct);
			target.children[0].parentNode.insertBefore(ct, target.children[0].nextSibling.nextSibling);
			target.children[0].parentNode.insertBefore(title, target.children[0].nextSibling.nextSibling);
		}else{
			document.getElementById("DOK-ct").innerHTML = "";
			document.getElementById("dok-layer-container").appendChild(privateFns.createSpinner());
		}
	},
	createSpinner: function(){
		let dokSpinner = document.createElement("i");
			dokSpinner.className = "fa fa-spinner fa-spin";
			dokSpinner.id = "dokspinner";
		return dokSpinner;
	},
	createDokLayerMenu: function(layerIds, gnr, bnr, list){
		let ct = document.getElementById("DOK-ct");
		ct.innerHTML = "";
		for(let key in layerIds){
			if(layerIds[key]){
				let node = $(document.getElementById(layerIds[key]).parentElement.parentElement).clone(true)
				node.appendTo(ct);
				$(node).find(".mapmenu-info")[0].onclick = function(){
					privateFns.merinfoClick(layerIds[key]);
				}
				if(document.getElementById(layerIds[key]+"-ct")){
					$(document.getElementById(layerIds[key]+"-ct")).clone(true).appendTo(ct);
					$(node).find(".mapmenu-expander")[0].onclick = function(){
						$(node).find(".mapmenu-expander").find("i").toggleClass("icon-Chevron-down").toggleClass("icon-Chevron-upFill");
						$(document.getElementById(layerIds[key]+"-ct")).toggle();
					}
				}
			}
		}
		document.getElementById("dokspinner").remove();
		privateFns.createDokLink(ct, gnr, bnr, list);
	},
	merinfoClick: function(id){
		$(".navtoggler").toggleClass("navtoggler-toggled");
		$(".mapmenu").toggleClass("nav-toggled");
		$(".layerinfo").toggleClass("layerinfo-show");
		$("#layerinfo-ct").html(layerhelp.getInfoTextFor(id));
	},
	createDokLink: function(container, gnr, bnr, list){
		setTimeout(function() {
			if(globals.map.getLayerById("markers").getSource().getFeatures()[0]){
				if(document.getElementById("doklink")){
					document.getElementById("doklink").remove();
				}
				let dokLink = document.createElement("a");
				let dokLinkHref;
				let dokLinkHTML;
				if(list){
					dokLinkHTML = "Lag rapport for " + list;
					dokLinkHref = 'http://diversus:8080/DOK/dok?list=' + list;
				}else{
					dokLinkHTML = "Lag rapport for " + gnr + "/" + bnr;
					dokLinkHref = 'http://diversus:8080/DOK/dok?gnr=' + gnr + '&bnr=' + bnr;
				}
				dokLink.href = dokLinkHref;
				dokLink.target = "_blank";
				dokLink.innerHTML = dokLinkHTML;
				dokLink.id = "doklink";
				container.appendChild(dokLink);
			}else{
				privateFns.createDokLink(container, gnr, bnr, list);
			}
		}, 2);
	},
	createGroupContainer: function (l) {
		var ul = document.createElement("ul");
		ul.id = l + "-ct";
		ul.className = "collapsed-layer-ct";
		return ul;
	},
	createGroupExpander: function (title) {
		var button = document.createElement("button");
		button.type = "button";
		button.className = "mapmenu-expander";
		button.setAttribute("aria-label", "Vis " + title);

		var icon = document.createElement("i");
		icon.className = "icon-Chevron-down";
		button.appendChild(icon);

		button.onclick = function (e) {
			if (e.currentTarget.parentElement.nodeName === "LI") {
				var label = e.currentTarget.parentElement.lastChild.lastChild.firstChild.textContent;
				privateFns.toggleAriaLabel(button, label);
				// Går gjennom alle ekspander-knappene i kartlagsmenyen
				$(".mapmenu").find(".mapmenu-expander").each(function (index, el) {
					var currentUl = e.currentTarget.parentElement.nextSibling;
					var thisUl = el.parentElement.nextSibling;
					if (el === e.currentTarget && index >= 0) {
						// hvis knappen er den det ble trykket på (index >= 0 er bare for å unngå feilmelding på ubrukt variabel..)
						$(el).find("i").toggleClass("icon-Chevron-down").toggleClass("icon-Chevron-upFill");
						$(currentUl).toggle();
					} else if ($(thisUl).find("#" + currentUl.id).length === 0) {
						// hvis knappen ikke er den det ble trykket på og ikke er foreldre til knappen det ble trykket på
						//$(el).find("i").toggleClass("oslo-chevron-down").toggleClass("oslo-chevron-up");
						//$(thisUl).hide();
					}
				});
			} else {
				var label2 = e.currentTarget.parentElement.textContent;
				privateFns.toggleAriaLabel(button, label2);
				$(e.currentTarget).find("i").toggleClass("icon-Chevron-down").toggleClass("icon-Chevron-upFill");
				$(e.currentTarget.parentElement.nextSibling).toggle();
			}
		};
		return button;
	},
	toggleAriaLabel: function (button, label) {
		if (button.getAttribute("aria-label").indexOf("Vis") > -1) {
			button.setAttribute("aria-label", "Skjul " + label);
		} else {
			button.setAttribute("aria-label", "Vis " + label);
		}
	},
	addSearchListener: function(){
		let target = document.querySelector('#eiendom-info-ct');
		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if(mutation.addedNodes[0] && mutation.addedNodes[0].id){
					let gnrBnr = mutation.addedNodes[0].innerHTML.split(" ")[0].split("/");
					privateFns.DOKHandler(gnrBnr[0], gnrBnr[1]);
				}
			});    
		});

		// configuration of the observer:
		var config = { attributes: true, childList: true, characterData: true };

		// pass in the target node, as well as the observer options
		observer.observe(target, config);
	},
};

clickFns = {
	DokClick: function(){
		$("#doklink").remove();
		$("#dokBtn").after("<a id='doklink' href =" + 'http://diversus:8080/DOK/dok?gnr=' + globals.gnr + '&bnr=' + globals.bnr +" target=_blank>" + globals.gnr + "_" + globals.bnr + ".pdf</a>");
	},
}

export default {
	initiate: function(hint,searchStr, url2, sesjon){
		privateFns.showHintWin(hint,searchStr, url2, sesjon);
	},
	modeInitiate: function(){
		let paramObject = {};
		let list;
		var pageurl = window.location.search.substring(1);
		var urlvariables = pageurl.split("&");
		urlvariables.forEach(function (urlVar) {
			var parametername = urlVar.split("=");
			paramObject[parametername[0]] = parametername[1];
		});
		if(paramObject["list"]){
			list = decodeURI(paramObject["list"]).replaceAll("\"", "").slice(1,-1);
		}
		if(paramObject["list"] || paramObject["gnr"]){				
			privateFns.DOKHandler(paramObject["gnr"], paramObject["bnr"], list);
		}	
		privateFns.addSearchListener();
	}
};